import Seo from "@/components/feature/Seo";
import PageHeader from "@/components/feature/PageHeader";
import { settings } from "@/mocks/siteData";
import { images } from "@/mocks/images";

export default function Settings() {
  const itemList = settings.map((s) => ({
    "@type": "ListItem",
    position: settings.indexOf(s) + 1,
    name: s.title,
  }));

  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "店铺设定大全", item: "/settings" },
        ],
      },
      {
        "@type": "CollectionPage",
        name: "洞洞杂货铺店铺设定大全",
        description: "洞洞杂货铺店铺设定详解：杂货店本体、墙上的洞、店主的规矩、深夜访客与村庄的百年秘密。",
        mainEntity: { "@type": "ItemList", itemListElement: itemList },
      },
    ],
  };

  return (
    <>
      <Seo
        title="洞洞杂货铺店铺设定大全｜杂货店、墙上的洞与村庄秘密"
        description="洞洞杂货铺店铺设定详解：那间乡下杂货店、墙上的神秘之洞、店主的规矩、深夜访客，以及村庄流传百年的秘密，一篇读懂全部设定。"
        keywords="洞洞杂货铺店铺设定,洞洞杂货铺墙上的洞,杂货店设定,村庄秘密"
        path="/settings"
        ogType="article"
        jsonLd={jsonLd}
      />
      <PageHeader
        crumb={[{ label: "首页", to: "/" }, { label: "店铺设定大全" }]}
        title="洞洞杂货铺店铺设定大全"
        subtitle="店铺本体、墙上的洞、店主的规矩、深夜的访客，再到村庄流传百年的秘密——关于这间杂货铺的设定，都在这里。"
      />

      <section className="w-full bg-background-50 py-12 md:py-16">
        <div className="mx-auto w-full max-w-6xl space-y-6 px-4 md:px-6">
          {settings.map((s, idx) => (
            <article
              key={s.id}
              className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200/70 bg-background-100 md:grid-cols-2"
            >
              <div
                className={`relative overflow-hidden bg-background-200 ${
                  idx % 2 === 1 ? "md:order-2" : ""
                }`}
              >
                <img
                  src={images[s.imgSeq]}
                  alt={s.title}
                  title={`洞洞杂货铺 ${s.title}`}
                  className="h-full min-h-[240px] w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                  {s.tag}
                </span>
              </div>
              <div className="flex flex-col justify-center p-6 md:p-8">
                <span className="font-heading text-3xl font-black text-background-300">
                  0{idx + 1}
                </span>
                <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950">
                  {s.title}
                </h2>
                <p className="mt-3 text-sm font-bold text-accent-700">{s.summary}</p>
                <div className="mt-3 space-y-3 text-sm leading-relaxed text-foreground-700">
                  {s.body.map((p) => (
                    <p key={p.slice(0, 12)}>{p}</p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}